import { css } from 'styled-components'

export default {
  colors: {
    gray: '#f4f4f3',
    blue: '#00175a',
    lightblue: '#006fcf',
    paybackBlue: '#0046aa',
    red: '#c1002b',
    peacockBlue: '#0046aa',
    grayblue: '#e5f0fa',
  },
  css: {
    fontBentonBlack: css`
      font-family: 'BentonSans';
      font-weight: 900;
    `,
  },
}
